import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BottomSheetConfig, BottomSheetData } from 'src/app/interfaces/mat.interface';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';
import { MakePaymentComponent } from '../../../planner/components/buy-tickets/components/make-payment/make-payment.component';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { MPassService } from '../../../planner/components/buy-tickets/components/make-payment/services/mpass.service';
import { AuthService, UserService } from 'src/app/services';
import { filter, from, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-make-payment-button',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './make-payment-button.component.html',
  styleUrls: ['./make-payment-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MakePaymentButtonComponent {
  private _matBottomSheetService = inject(MatBottomSheetService);
  private _breakpointsService = inject(BreakpointsService);
  private _mpassService = inject(MPassService);
  private _authService = inject(AuthService);
  private _userService = inject(UserService);
  
  private _isMobile = computed(() => this._breakpointsService.isMobile());
  public isWaitingForResponse = computed(() => this._mpassService.isWaitingForResponse());
    
  async handleMakePaymentClick(): Promise<void> {
    // await this._openMakePaymentBottomSheet();
    if (!this._authService.userValue) {
      this._userService.login();
      return;
    }

    if (this.isWaitingForResponse())
      return;

    this._mpassService.isWaitingForResponse.set(true);
    this._mpassService.getQrCode().pipe(
      tap(res => {
        if (res.hashUrl) 
          this._mpassService.hashUrl.set(res.hashUrl);

        if (res.message)
          this._mpassService.errorMsg.set(res.message);

        this._mpassService.isWaitingForResponse.set(false);
      }),
      filter(res => res?.status === 200),
      switchMap(() => from(this._openMakePaymentBottomSheet()))
    ).subscribe();
  }

  private async _openMakePaymentBottomSheet(): Promise<void> {
    const bottomSheetConfig: BottomSheetConfig<MakePaymentComponent, BottomSheetData> = {
      component: MakePaymentComponent,
      panelClass: this._isMobile() ? 'make-payment-bottom-sheet--mobile' : 'make-payment-bottom-sheet--desktop',
    }    
    
    await this._matBottomSheetService.openMatBottomSheet(bottomSheetConfig);
  }
}
